import builder from './audience-manager-builder';
import charts from './audience-manager-charts';
import overview from './audience-manager-overview';

export default {
    namespaced: true,
    modules: {
        builder,
        charts,
        overview
    }
};